module.exports = __webpack_public_path__ + "img/userImage.6b373124.png";